module.exports = __webpack_public_path__ + "img/ysgj_034@2x.afddaba0.png";